export default "__VITE_ASSET__9b114f60__"